import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Subtitle, Description, Titlespan2, Title } from '../../components/title/index';
import '../skills/skills.scss';
import "../../assets/scss/variable.scss";


const Skills = (props) => {
    return (
        <section className="skills-wrapper" id="skills">
            <Container>
                <Row>
                    <Col md={props.size ? 12 - props.size : 6} sm={0}>
                        <div className="skills-image">
                            {/*<Image Path={Skills_img} Class="logo-img" />*/}
                        </div>
                    </Col>
                    <Col md={props.size ? props.size : 6} sm={12}>
                        <div className="skills-content-block main-title-wrapper">
                            <Titlespan2
                                Class="sitemain-subtitle"
                                Name={props.title}
                                Label=""
                            />
                            <Subtitle
                                Class="site-subtitle2"
                                Name={props.subtitle}
                            />

                            <Description
                                Class="skills-dec"
                                Name={props.description}
                            />
                            <div className="progress-outer-block">
                               {props.children}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Skills;
